import { createContext } from 'react';

export interface FeedbackContextType {
  isEnabled: boolean;
  showFeedback: (context?: FeedbackContext) => void;
  sendFeedback: (message: string, context?: FeedbackContext) => void;
  setEnabled: (enabled: boolean) => void;
}

export interface FeedbackContext {
  page?: string;
  feature?: string;
  userAction?: string;
  severity?: 'low' | 'medium' | 'high' | 'critical';
  errorId?: string;
  tags?: Record<string, string>;
  extra?: Record<string, unknown>;
}

export const FeedbackContext = createContext<FeedbackContextType | undefined>(undefined);